"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var resource_1 = require("../../resource");
var component = /** @class */ (function (_super) {
    tslib_1.__extends(component, _super);
    function component() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.route = '/component';
        return _this;
        // non functional.
        // Cant call the delete method? Likely a bug in bugzilla.
        // (error): "For security reasons, you must use HTTP POST to call the 'delete' method."
        /**
         *
         * @param {number | Array<number>} ids Id(s) of the components to update.
         * @param {any} update The update to carry out.
         */
        // async delete(ids: Array<number> | number): Promise<Array<{ id: number }>> {
        //     let result = await this.makeRequest(this.axios.delete(`${this.route}/${ids}`, {
        //         // params: { ids: Array.isArray(ids) ? ids.join(',') : ids }
        //     }));
        //     return result;
        // }
    }
    // No endpoint for getting components seems to exist. Naughty api. 
    // Components are returned with products however. "rest/product/<product_id>"
    // http://bugzilla.readthedocs.io/en/latest/api/core/v1/component.html
    // TODO(Reece): retrieve the newly created component and return that instead of an ID. 
    /**
     * Create a new Component.
     *
     * @param {Component} component Component object to be created. Required fields are defined in the Component interface.
     * @returns {number} Return the ID of the created Component.
     */
    component.prototype.create = function (component) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({
                            url: "" + this.route,
                            method: 'POST',
                            data: component
                        })];
                    case 1:
                        results = _a.sent();
                        return [2 /*return*/, results.id];
                }
            });
        });
    };
    /**
     *
     * @param {number | Array<number>} ids Id(s) of the components to update.
     * @param {any} update The update to carry out.
     */
    component.prototype.update = function (ids, update) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        update.ids = Array.isArray(ids) ? ids : ids = [ids];
                        return [4 /*yield*/, this.makeRequest({
                                url: this.route + "/" + ids[0],
                                method: 'PUT',
                                data: update
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return component;
}(resource_1.resource));
exports.component = component;



//////////////////
// WEBPACK FOOTER
// ../node_modules/bzrest/lib/resources/products/components/components.js
// module id = 986
// module chunks = 0